










































































































































import { Vue, Component } from 'vue-property-decorator'
import { Pages } from '@/pages'
import NavButton from '@/components/shared/NavButton.vue'
import { errorHandler, getUrl } from '@/api/utils/http-helpers'
import axios from 'axios'
import { BackupSettings } from '@/generated/model/backupSettings'
import {ISnackbar} from '@/model'
import { mapGetters, mapState } from 'vuex'
import { permissions } from '@/userUtils'
import { IUser } from '@/libs/auth'

@Component({
  components: { NavButton },
  computed: {
    ...mapGetters('user', ['userPermissions']),
    ...mapState('environment', ['user'])
  }
})
export default class BackupRestore extends Vue {
  private homeRouteLink: any = Pages.HOME.routeLink
  private userPermissions!: string[]
  private restoreDialog: boolean = false
  private backingUp: boolean = false
  private backupSettings: BackupSettings = {}
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }
  private user!: IUser

  async mounted() {
    const backupSettingsUrl = getUrl('/backup/settings')
    await axios
        .get(backupSettingsUrl)
        .then((response) => {
          this.backupSettings = response.data
        })
        .catch(error => {
          errorHandler(error)
          console.error(error)
        })
  }

  private async backup() {
    this.backingUp = true
    await this.saveBackup()
  }

  private async saveBackup() {
    const url = getUrl(`/backup`)
    await axios
        .post(url, null, {
          responseType: 'blob'
        })
        .then((response) => {
          if (response.status === 200) {
            const blob = new Blob([response.data], { type: 'application/zip' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'backup.zip'
            link.click()
            URL.revokeObjectURL(link.href)
            this.snackBarHandler(true, 'success', String(this.$t('backupRestore.backupSucceeded')))
          }
        })
        .catch((error) => {
          this.snackBarHandler(true, 'error', String(this.$t('backupRestore.backupFailed')))
          console.error(error)
        })
        .finally(() => {
          this.backingUp = false
        })
  }

  private openRestoreDialog () {
    this.restoreDialog = true
  }

  private openFileDialog () {
    (this.$refs.fileInput as HTMLInputElement).click()
    this.restoreDialog = false
  }

  private async restoreBackup(event: any) {
    const restoreUrl = getUrl('/backup/restore')
    const file = event.target.files[0]
    if (!file) {
      return
    }
    if (!file.name.toLowerCase().endsWith('.zip')) {
      this.snackBarHandler(true, 'warning', String(this.$t('backupRestore.onlyZipFilesAllowed')))
      return
    }
    const FormData = require('form-data')
    const data = new FormData()
    data.append('file', file)
    await axios
        .post(restoreUrl, data)
        .then((response) => {
          console.log('resp', response)
          if (response.status === 202) {
            setTimeout(() => {
              this.snackBarHandler(true, 'success', String(this.$t('backupRestore.restoreSucceeded')), 500)
              window.location.reload()
            }, 1500)
          }
        })
        .catch(e => {
          this.snackBarHandler(true, 'error', this.getErrorMessage(e, String(this.$t('backupRestore.restoreFailed'))))
        })
  }

  private async updateBackupSettings() {
    const backupSettingsUrl = getUrl('/backup/settings')
    this.backupSettings.frequency = this.backupSettings.frequency && this.backupSettings.frequency > 0
        ? this.backupSettings.frequency
        : 1
    await axios
        .put(backupSettingsUrl, this.backupSettings)
        .then((response) => {
          this.backupSettings = response.data
          this.snackBarHandler(true, 'success', String(this.$t('general.settingsSaved')))
        })
        .catch(error => {
          this.snackBarHandler(true, 'error', String(this.$t('general.settingsSaveFail')))
          errorHandler(error)
          console.error(error)
        })
  }

  private snackBarHandler (state: boolean, color: string, text: string, timeout?: number) {
    this.snackbar.show = state
    this.snackbar.color = color
    if (text && text !== '') {
      this.snackbar.text = text
    }
    if (timeout) {
      this.snackbar.timeout = timeout
    }
  }

  private getErrorMessage(error: any, fallback: string) {
    const detail = error && error.response && error.response.data && error.response.data.message
    return detail ? `${fallback}: ${detail}` : fallback
  }

  private convertToLocalTime(utcDateTime: Date) {
    const formatter = new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short'
    } as Intl.DateTimeFormatOptions)
    return formatter.format(new Date(utcDateTime))
  }

  private isDisabledBackupRestore() {
    return !this.userPermissions.includes(permissions.MODIFYBACKUPRESTORE) || this.isDemo()
  }

  private checkDisabledField() {
    this.snackbar.show = false
    this.$nextTick(() => {
      if (this.isDisabledBackupRestore()) {
        this.snackBarHandler(true, 'warning', String(this.$t('settings.permissionDenied')))
      }
    })
  }

  private isDemo(): boolean {
    return this.user != null
  }
}
